export const DEFAULT_TABLER_ICON = "circle";

export const LEGACY_TABLER_ICON_NAMES: Record<string, string> = {
  branch: "git-branch",
  "book-open": "book-2",
  chart: "chart-bar",
  "check-circle": "checkbox",
  document: "file-text",
  form: "forms",
  handshake: "heart-handshake",
  layers: "layers-intersect",
  lightbulb: "bulb",
  store: "building-store",
  target: "target-arrow",
};

export function normalizeTablerIconName(icon: string) {
  const normalized = icon.trim().toLowerCase();
  return LEGACY_TABLER_ICON_NAMES[normalized] ?? normalized;
}

export function prettifyTablerIconName(icon: string) {
  return normalizeTablerIconName(icon)
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
